import { observable, action } from 'mobx'
import Api from '@api/yun_xuan/liteAppApi'
import { message } from 'hljd'
import { hashHistory } from 'react-router'
import { getObjValue } from '@hlj/hlj-utils'
import { getSessionMerchantInfo } from '@merchant-backend/util'
import mainStore from '@components/Main/store'
import { SHOP_PRODUCTS_PATH } from '@constant'

class Store {
  @observable statusAuthorize = 0
  @observable visible = false
  @observable status = 0
  @observable failVisible = false
  @observable nick_name = ''
  @action
  getAuth = async () => {
    let return_url = window.location.href.split('#')
    let newTab = window.open('about:blank')
    let {
      data: { url },
      success
    } = await Api.getAuthUrlApi({
      redirect_uri: escape(return_url[0] + '#/localMerchant/liteApp/manage')
    })
    if (success) {
      this.visible = true
      this.failVisible = false
      newTab.location.href = url
    }
  }
  @action
  doneAuth = async () => {
    let {
      data: { auth_status },
      success
    } = await Api.getAuthStatusApi({
      merchant_id: getSessionMerchantInfo().id
    })
    if (!success) return
    if (+auth_status === 1) {
      this.visible = false
      hashHistory.push('/localMerchant/liteApp/manage')
      return message.success('授权小程序成功')
    } else {
      this.visible = false
      return message.error('授权小程序失败')
    }
  }
  @action
  cancel = type => () => {
    this[type] = false
  }
  @action
  authConfirm = async () => {
    let { success } = await Api.authConfirmApi()
    if (success) {
      this.failVisible = false
      message.success('授权小程序成功')
    }
  }

  @observable vipVisible = false
  @observable shareVisible = false
  @action
  judgeOvertime = () => {
    const {
      shopInfo: { merchant_weapp }
    } = mainStore
    let type = getObjValue(merchant_weapp, 'type')
    let status = getObjValue(merchant_weapp, 'status')
    if (type == 1 && status == 2) {
      this.shareVisible = true
    }
    // if (type == 2 && status == 2) {
    //   this.vipVisible = true
    // }
  }

  @action
  toVip = () => {
    window.location.href = '#/localMerchant/marketingCenter/detail/65/2'
  }
  @action
  toPro = () => {
    hashHistory.push(SHOP_PRODUCTS_PATH)
  }
  @action
  close = type => () => {
    this[type] = false
  }
}

export default new Store()
